exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".frame-landscape-big-1{\n    fill:#bdc4c9;\n}", ""]);
